import React from 'react'
import { Button, ButtonProps } from '../../../Button'
import Icon from '../../../Icon'

export type ExpiredChatProps = {
  message: string
  action: ButtonProps
}

export const Expired = (props: ExpiredChatProps) => {
  const { message, action } = props

  return (
    <div className="flex flex-col items-center justify-center gap-4">
      <Icon name="MessagesSquare" size={30} className="text-gray-400" />
      <div className="text-base">{message}</div>
      <Button {...action} />
    </div>
  )
}
